import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions, combineActions } from 'redux-actions';
import { upsertResourceSetupUndo, upsertResource, upsertResources, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';

import { mkFreeToSpend } from './freeToSpendTypes';
import * as actions from './freeToSpendActions';

const freeToSpendReducer = handleActions({

  [actions.createFreeToSpend]: (state, { payload: freeToSpend }) => upsertResource(state, freeToSpend),

  [actions.createFreeToSpendSuccess]:
    (state, { payload: freeToSpend, asyncDispatch }) => {
      asyncDispatch(actions.getFreeToSpend());
      return upsertResource(state, freeToSpend);
    },

  [actions.updateFreeToSpend]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateFreeToSpend),
  [actions.updateFreeToSpendSuccess]:
    (state, { payload: freeToSpend }) => upsertResource(state, freeToSpend),


  [actions.deleteFreeToSpend]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createFreeToSpend),
  [actions.deleteFreeToSpendSuccess]:
    (state, { payload: freeToSpend }) => upsertResource(state, freeToSpend),

  [combineActions(
    actions.createFreeToSpendFailure,
    actions.updateFreeToSpendFailure,
    actions.deleteFreeToSpendFailure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getFreeToSpend());
    return resetResources(state, error);
  },

  [actions.getFreeToSpend]:
    (state) => state.merge({ isLoading: true }),
  [actions.getFreeToSpendSuccess]:
    (state, { payload: resources, asyncDispatch }) => {
      const newState = upsertResources(state, resources);
      if (newState.resourcesById.size === 0 && !newState.loadPending) {
        asyncDispatch(actions.createFreeToSpend(mkFreeToSpend({})));
      }
      return newState;
    },
  [actions.getFreeToSpendFailure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const FREE_TO_SPEND_REDUCER_KEY = 'freeToSpendStore';
export default freeToSpendReducer;
